import axios from "axios"
import { cca_config } from '../../CCA_ENV_CONF/env'
import store from '@/store'
import router from '@/router'

export default {
    makeRequest(url) {
        const auth_info = store.getters['authInfo']
        let token = ''

        if (auth_info) {
            token = (Object.prototype.hasOwnProperty.call(auth_info, 'access_token'))?auth_info.access_token:''
        }

        const instance = axios.create({
            baseURL: url,
            withCredentials: false,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })

        // Add a response interceptor
        instance.interceptors.response.use(
            response => response, // Return response if successful
            error => {
                if (error.response && error.response.status === 401) {
                    console.warn("Token expired. Logging out...");
                    localStorage.clear();
                    router.push('/login'); // Redirect to login page
                }
                return Promise.reject(error);
            }
        );

        return instance
    },

    clinique() {
        return this.makeRequest(cca_config.C_URL+cca_config.C_URL_CLINIQUE_API)
    },

    comptabilite() {
        return this.makeRequest(cca_config.C_URL+cca_config.C_URL_CAISSE_API)
    },
    
    stock() {
        return this.makeRequest(cca_config.C_URL+cca_config.C_URL_STOCK_API)
    },

    online() {
        return this.makeRequest('https://google.com')
    }
}